import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { FormFieldRow } from "@/Common/Components/Forms/FormFieldRow";
import { SelectKVPControl } from "@/Common/Components/Inputs/SelectKVPControl";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { InformationLoadingComponent } from "@/Common/Components/Loader/InformationLoadingComponent";
import { IMap } from "@/Common/Models/IMap";
import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";
import { ValueSetType } from "../Constants/ValueSetType";
import { PractitionerModel } from "../Models/PractitionerModel";
import { RvqDomainValue } from "../Models/RvqDomainValue";
import { QuebecVaccinationRegistryHelper } from "../QuebecVaccinationRegistryHelper";

interface RvqPractitionerSearchProps {
    roles: IMap<RvqDomainValue>;
    onPractitionerSelect: (practitioner: PractitionerModel, then?: () => void) => void;
    searchFields: {
        givenName: string;
        familyName: string;
        role: string;
        permitNumber: string;
    };
    showList: boolean;
    practitioners: PractitionerModel[];
    onChange: (value: string, key: string) => void;
    onEnterKeyDown?: () => void;
    onSearchClick?: () => void;
    isLoading?: boolean;
    disableSearchButton?: boolean;
}

class RvqPractitionerSearch extends BaseReactComponent<RvqPractitionerSearchProps, null> {
    public render(): JSX.Element {
        const {
            givenName,
            familyName,
            role,
            permitNumber
        } = this.props.searchFields;

        const onKeyDown = (e: React.KeyboardEvent): void => e.keyCode === 13 && this.props.onEnterKeyDown?.();

        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="row" style={{ marginTop: "10px" }}>
                        <div className="col-md-12">
                            <FormFieldRow
                                isEditMode
                                labelValueKey="FirstNameLabel"
                            >
                                <TextboxControl
                                    id="practitioners_firstName"
                                    onChange={val => this.props.onChange(val, "givenName")}
                                    value={givenName}
                                    onKeyDown={onKeyDown}
                                    style={{ marginBottom: "10px" }}
                                />
                            </FormFieldRow>
                            <FormFieldRow
                                isEditMode
                                labelValueKey="LastNameLabel"
                            >
                                <TextboxControl
                                    id="practitioners_lastName"
                                    onChange={val => this.props.onChange(val, "familyName")}
                                    value={familyName}
                                    onKeyDown={onKeyDown}
                                    style={{ marginBottom: "10px" }}
                                />
                            </FormFieldRow>
                            <FormFieldRow
                                isEditMode
                                labelValueKey="PermitNumberLabel"
                            >
                                <TextboxControl
                                    id="practitioners_permitNumber"
                                    onChange={val => this.props.onChange(val, "permitNumber")}
                                    value={permitNumber}
                                    onKeyDown={onKeyDown}
                                    style={{ marginBottom: "10px" }}
                                />
                            </FormFieldRow>
                            <FormFieldRow
                                isEditMode
                                labelValueKey="RoleLabel"
                            >
                                <SelectKVPControl
                                    Callback={val => this.props.onChange(val, "role")}
                                    AvailableValues={this.practitionerRoles}
                                    Value={role}
                                    IncludeEmptyChoice
                                    style={{ height: "34px", marginBottom: "10px" }}
                                />
                            </FormFieldRow>
                        </div>
                    </div>
                </div>
                {this.props.onSearchClick && (
                    <div className="col-md-12" onClick={e => e.stopPropagation()} style={{ minHeight: "39px", marginTop: "10px", textAlign: "right" }}>
                        {this.props.isLoading
                            ? <span><InformationLoadingComponent smallVersion /></span>
                            : (
                                <button
                                    className="btn btn-primary"
                                    disabled={this.props.isLoading || this.props.disableSearchButton}
                                    onClick={e => {
                                        e.stopPropagation();
                                        this.props.onSearchClick();
                                    }}
                                >
                                    {cacheStore.GetString("SearchLabel")}
                                </button>
                            )
                        }
                    </div>
                )}
            </div>
        );
    }

    private get practitionerRoles(): KeyValuePair<string, string>[] {
        return KeyValuePair.fromMapOfStrings(QuebecVaccinationRegistryHelper.getTranslatedDictionary(this.props.roles, ValueSetType.PractitionnerRole), false);
    }
}

export { RvqPractitionerSearch };
